export default {"src":"/_next/static/media/lastServicePic.d9c20a5b.svg","height":37,"width":572,"blurWidth":0,"blurHeight":0};